import { db } from "../firebase-config";
import { collection, getDoc, deleteDoc, doc, updateDoc, query, addDoc, onSnapshot, where } from "firebase/firestore";

export const getSuppliers= async(organization) => {
    var docRef = doc(db, "organizations", organization, "static_documents", "suppliers");
    return await getDoc(docRef)
}

export const addSupplier = async (organization, supplier) => {
    try {
        const suppliersRef = collection(db, "organizations", organization, "suppliers"); 
        const supplierDoc = await addDoc(suppliersRef, {
            ...supplier
        });
        
        return { success: true, data: { id: supplierDoc.id, ...supplier }, error: null };
    } catch (error) {
        console.error("Error adding supplier:", error);
        return { success: false, error: error.message || 'Failed to add supplier' };
    }
};

export const organizationSupplierSnapshotListener = (organization, onSupplierUpdate) => {
    const supplierQuery = query(collection(db, "organizations", organization, "suppliers"))
    const unsubscribe = onSnapshot(supplierQuery, (querySnapshot) => {
        const supplierItems = [];
        querySnapshot.forEach((doc) => {
          supplierItems.push({ id: doc.id, ...doc.data() });
        });
        onSupplierUpdate(supplierItems);
    })
    return () => unsubscribe()    
}

export const updateSupplier = async (organization, supplierId, supplier) => {
    try {
        const supplierRef = doc(db, "organizations", organization, "suppliers", supplierId);

        // Remove undefined fields
        const filteredSupplier = Object.fromEntries(
            Object.entries(supplier).filter(([_, value]) => value !== undefined)
        );

        await updateDoc(supplierRef, filteredSupplier);
        return { success: true, data: { id: supplierId, ...filteredSupplier }, error: null };
    } catch (error) {
        console.error("Error updating supplier:", error);
        return { success: false, error: error.message || 'Failed to update supplier' };
    }
};

export const supplierSnapshotListener = (organization, id, onSupplierUpdate) => {
    const supplierDocRef = doc(db, "organizations", organization, "suppliers", id);

    const unsubscribe = onSnapshot(supplierDocRef, (docSnapshot) => {
        if (docSnapshot.exists()) {
            onSupplierUpdate({ id: docSnapshot.id, ...docSnapshot.data() });
        } else {
            onSupplierUpdate(null);
        }
    });
    return unsubscribe;
};


export const deleteSupplier = async (organization, supplierId) => {
    try {
        const supplierRef = doc(db, "organizations", organization, "suppliers", supplierId);
        await deleteDoc(supplierRef);

        return { success: true, error: null };
    } catch (error) {
        console.error("Error deleting supplier:", error);
        return { success: false, error: error.message || 'Failed to delete supplier' };
    }
};